export default __webpack_public_path__ + "static/media/content4.3ab39679.jpg";